import { Component, Input } from '@angular/core';

@Component({
  selector: 'tun-sort-icon',
  templateUrl: './sort-icon.component.html',
  styleUrls: ['./sort-icon.component.scss']
})
export class SortIconComponent {

  @Input() color: string;

  constructor() { }

}
